import React, { useState } from "react";
import {
  Backdrop,
  BottomNavigation,
  Box,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@material-ui/lab";
import { useNavStyles } from "./navStyles";

/**
 * Basic absolute positioned bottom navigation button to be used any screen
 */

interface SpeedDialActionItem {
  icon: React.ReactNode;
  name: string;
  onClick: () => void;
}

interface BottomNavButtonProps {
  disabled?: boolean;
  disabledLeft?: boolean;
  disabledRight?: boolean;
  onClick?: () => void;
  text: string;
  secondAction?: boolean;
  secondActionText?: string | React.ElementType;
  secondActionOnClick?: () => void;
  actionIcon?: any;
  secondActionIcon?: any;
  fixed?: boolean;
  loading?: boolean;
  fabIcon?: React.ReactNode;
  showSpeedDial?: boolean;
  speedDialActions?: SpeedDialActionItem[];
  fabOnClick?: () => void;
  speedDialAlwaysOpen?: boolean;
}

const BottomNavButton = (props: BottomNavButtonProps) => {
  const {
    disabled,
    fixed,
    loading,
    fabIcon,
    showSpeedDial = false,
    speedDialActions = [],
    fabOnClick,
    speedDialAlwaysOpen = false,
  } = props;

  const [speedDialOpen, setSpeedDialOpen] = useState(speedDialAlwaysOpen);
  const classes = useNavStyles({ fixed, loading, disabled });

  return (
    <>
      <BottomNavigation className={classes.bottomNav} showLabels={false} />

      {fabIcon && (
        <>
          {showSpeedDial ? (
            <SpeedDial
              ariaLabel="FAB Actions"
              className={classes.speedDial}
              icon={speedDialAlwaysOpen ? fabIcon : <SpeedDialIcon icon={fabIcon} />}
              onClose={() => !speedDialAlwaysOpen && setSpeedDialOpen(false)}
              onOpen={() => !speedDialAlwaysOpen && setSpeedDialOpen(true)}
              open={speedDialAlwaysOpen ? true : speedDialOpen}
              direction="up"
              FabProps={{ 
                disabled: disabled,
                onClick: speedDialAlwaysOpen ? fabOnClick : undefined
              }}
            >
              {speedDialActions.map((action) => (
                <SpeedDialAction
                  key={action.name}
                  icon={action.icon}
                  tooltipTitle={action.name}
                  onClick={action.onClick}
                />
              ))}
            </SpeedDial>
          ) : (
            <SpeedDial
              ariaLabel="FAB Action"
              className={classes.speedDial}
              icon={fabIcon}
              onClick={fabOnClick}
              FabProps={{ disabled: disabled }}
              open={false}
            />
          )}
        </>
      )}

      <Backdrop open={loading as boolean} className={classes.backDrop}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <CircularProgress color="inherit" />
          <Box mt={3}>
            <Typography variant="subtitle2">
              Tallennetaan tositetta.. Odota hetki...
            </Typography>
          </Box>
        </Box>
      </Backdrop>
    </>
  );
};
export default BottomNavButton;
